/**
 * @generated SignedSource<<c6947b24114ba34457af3f2388c7e932>>
 * @relayHash f9f327677fc75075e3445eefff0adb7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b155ba0c7b712cff3dba073a1d0a732773b5329d9a77903fad47e2d15659eb67

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOAggregationType = "AVG" | "COUNT" | "COUNT_DISTINCT" | "MAX" | "MIN" | "PERCENTILE" | "SUM" | "%future added value";
export type JiraCFOBoardPerformanceStatus = "FAST" | "MODERATE" | "SLOW" | "%future added value";
export type JiraCFOFilterOperator = "EQUALS" | "IN" | "%future added value";
export type JiraCFOMetricInput = {
  aggregation?: JiraCFOAggregationInput | null | undefined;
  alias?: string | null | undefined;
  name: string;
  summarize?: boolean | null | undefined;
};
export type JiraCFOAggregationInput = {
  type: JiraCFOAggregationType;
  value?: number | null | undefined;
};
export type JiraCFODimensionInput = {
  alias?: string | null | undefined;
  name: string;
};
export type JiraCFOFilterInput = {
  boardFilter?: JiraCFOBoardFilterInput | null | undefined;
  dimensionFilter?: JiraCFODimensionFilterInput | null | undefined;
};
export type JiraCFOBoardFilterInput = {
  creatorAccountId?: ReadonlyArray<string> | null | undefined;
  keyword?: string | null | undefined;
  performanceStatus?: ReadonlyArray<JiraCFOBoardPerformanceStatus | null | undefined> | null | undefined;
};
export type JiraCFODimensionFilterInput = {
  name: string;
  operator: JiraCFOFilterOperator;
  values: ReadonlyArray<string>;
};
export type BoardPerformanceTabsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  dimensions?: ReadonlyArray<JiraCFODimensionInput> | null | undefined;
  endDate: AGG$DateTime;
  filters?: ReadonlyArray<JiraCFOFilterInput> | null | undefined;
  first?: number | null | undefined;
  metrics: ReadonlyArray<JiraCFOMetricInput>;
  startDate: AGG$DateTime;
};
export type BoardPerformanceTabsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardPerformanceTabSummary" | "BoardPerformanceTabTable">;
};
export type BoardPerformanceTabsQuery = {
  response: BoardPerformanceTabsQuery$data;
  variables: BoardPerformanceTabsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dimensions"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metrics"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = {
  "kind": "Variable",
  "name": "dimensions",
  "variableName": "dimensions"
},
v10 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v11 = {
  "kind": "Variable",
  "name": "metrics",
  "variableName": "metrics"
},
v12 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v13 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v15 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v16 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "BoardPerformanceTabsQuery",
    "selections": [
      {
        "args": (v13/*: any*/),
        "kind": "FragmentSpread",
        "name": "BoardPerformanceTabSummary"
      },
      {
        "args": [
          (v14/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "BoardPerformanceTabTable"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BoardPerformanceTabsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "boardPerformanceSummary",
            "args": (v13/*: any*/),
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCFOBoardPerfStats",
                        "kind": "LinkedField",
                        "name": "boardPerfStats",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "slowBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "moderateBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fastBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "slowBoardThreshold"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fastBoardThreshold"
                          }
                        ]
                      }
                    ],
                    "type": "JiraCFOBoardPerformanceMetricSummary"
                  }
                ]
              }
            ]
          },
          {
            "alias": "boardPerformanceTableValues",
            "args": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v15/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "args": [
                  (v14/*: any*/),
                  (v16/*: any*/)
                ],
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "concreteType": "JiraCFOMetric",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": true,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "boardId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "boardName"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "boardCreator",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "perfStatus"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "projectKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "optimizationSuggestion"
                              }
                            ],
                            "type": "JiraCFOBoardPerformanceDataRow"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b155ba0c7b712cff3dba073a1d0a732773b5329d9a77903fad47e2d15659eb67",
    "metadata": {},
    "name": "BoardPerformanceTabsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e13f8b93277d19305cc328d266870fab";

export default node;
